import { ReferralWithdrawsPanel } from './ReferralWithdrawsPanel'

type ReferralWithdrawsTabProps = {
  referralId: string
}

export const ReferralWithdrawsTab = ({ referralId }: ReferralWithdrawsTabProps) => {
  return <ReferralWithdrawsPanel referralId={referralId} />
}

// Название вкладки для использования в TabGroup
export const REFERRAL_WITHDRAWS_TAB_LABEL = 'Исходящие'

